import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Sidebar } from './components/Sidebar.jsx';
import { Home } from './pages/home/Home.jsx';
import { Customers } from './pages/customers/Customers.jsx';
import { DrawerProvider } from './components/DrawerContext.jsx'; // Context'i import edin
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Packages } from './pages/packages/Packages.jsx';
import OrderPage from './pages/orders/Orders.jsx';
import Login from './pages/login/Login.jsx';
import { AuthProvider, useAuth } from './pages/login/AuthContext.jsx'; // Import useAuth here
// import PrivateRoute from './pages/login/PrivateRoute.jsx';
import { PrivateRoute, AdminRoute } from './pages/login/AuthContext.jsx';

import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation
import React from 'react';
import { Navigate } from 'react-router-dom';
import Dealer from './pages/dealer/Dealer.jsx';
import OrderForm from './pages/orders/orderForm/OrderForm.jsx';
import CustomersDetails from './pages/customers/CustomersDetails.jsx';
import LicenseRequestForm from './pages/license/LicenseRequestForm.jsx';
import LicensePage from './pages/license/LicensePage.jsx';
import NotFound from './components/NotFound.jsx';
import Dealers from './pages/dealer/Dealers.jsx';
import DealerDetails from './pages/dealer/DealerDetails.jsx';
import Offer from './pages/offer/Offer.jsx';
import UserProfile from './pages/users/UserProfile.jsx';
import Certificate from './pages/certificate/Certificate.jsx';
import CertificaPage from './pages/certificate/CertificaPage.jsx';
import SupportList from './pages/support/SupportList.jsx';
import SupportReport from './pages/support/SupportReport.jsx';
import FiyatHesaplama from './pages/fiyat/FiyatHesaplama.jsx';
import TeklifBelgesi from './pages/teklif/TeklifBelgesi.jsx';
import SistemMesajlari from './pages/sistemMesajlari/SistemMesajlari.jsx';
import GastoraPackages from './pages/gastora/packages/GastoraPackages.jsx';
import GastoraOrders from './pages/gastora/orders/GastoraOrders.jsx';
import GastoraOrderForm from './pages/gastora/orders/GastoraOrderForm.jsx';
import GastoraLicensePage from './pages/gastora/license/GastoraLicensePage.jsx';
import GastoraLicenseRequestForm from './pages/gastora/license/GastoraLicenseRequestForm.jsx';
import GastoraLicenseList from './pages/gastora/license/GastoraLicenseList.jsx';
import PdksPackages from './pages/pdks/PdksPackages.jsx';
import PdksLicenses from './pages/pdks/PdksLicenses.jsx';
import PdksOrders from './pages/pdks/PdksOrders.jsx';
import PdksOrderForm from './pages/pdks/PdksOrderForm.jsx';
import { NotificationBell } from './components/NotificationBell.jsx';
import { SistemMesajPopUp } from './components/SistemMesajPopUp.jsx';

function App() {
  const hostname = window.location.hostname;
  const isCertificateDomain = hostname.startsWith("verify.");

  if (isCertificateDomain) {
    // Sadece sertifika sayfası
    document.title = "Pozitif Ofis | Sertifika Doğrulama";
    return (
      <Router>
        <Routes>
          <Route path="/:uid" element={<CertificaPage />} />
        </Routes>
      </Router>
    );
  }
  document.title = "Pozitif Ofis | Lisans Sistemi";
  return (
    <AuthProvider>
      <DrawerProvider>
        <Router>
          <AppContent />
        </Router>
      </DrawerProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isTeklifBelgesi = location.pathname.startsWith('/teklif-belgesi');

  return (
    <>
      {!isLoginPage && (
        <PrivateRoute>
          {!isTeklifBelgesi && <Sidebar />}
        </PrivateRoute>
      )}
      <div className={isTeklifBelgesi ? 'container-fullscreen' : 'container'}>
          {!isTeklifBelgesi && !isLoginPage && (
            <>
              <NotificationBell />
              <SistemMesajPopUp />
            </>
          )}
            <Routes>
              <Route
                path="/login"
                element={<LoginRedirect />}
              />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="/musteriler"
                element={
                  <PrivateRoute>
                    <Customers element={<Navigate to="/" replace />} />
                  </PrivateRoute>
                }
              />

              <Route
                path="/musteriler/:id"
                element={
                  <PrivateRoute>
                    <CustomersDetails/>
                  </PrivateRoute>
                }
              />

              <Route
                path="/paketler"
                element={
                  <PrivateRoute>
                    <Packages />
                  </PrivateRoute>
                }
              />
              <Route
                path="/siparisler"
                element={
                  <PrivateRoute>
                    <OrderPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sertifika"
                element={
                  <AdminRoute>
                    <Certificate/>
                  </AdminRoute>
                }
              />
              <Route
                path="/404"
                element={
                <PrivateRoute>
                  <NotFound />
                </PrivateRoute>
                }
              />
              <Route
                path="/siparis"
                element={
                  <PrivateRoute>
                    <OrderForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="/siparis/:id"
                element={
                  <PrivateRoute>
                    <OrderForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="/siparis/musteri/:musteriId"
                element={
                  <PrivateRoute>
                    <OrderForm />
                  </PrivateRoute>
                }
              />
               <Route
                path="lisanslar/lisans-talep"
                element={
                  <PrivateRoute>
                    <LicenseRequestForm/>
                  </PrivateRoute>
                }
              />

              <Route
                path="lisanslar/lisans-talep/:id"
                element={
                  <PrivateRoute>
                    <LicenseRequestForm/>
                  </PrivateRoute>
                }
              />
              <Route
                path="lisanslar/lisans-talep/musteri/:customerId"
                element={
                  <PrivateRoute>
                    <LicenseRequestForm/>
                  </PrivateRoute>
                }
              />

              <Route
                path="/lisanslar"
                element={
                  <PrivateRoute>
                    <LicensePage/>
                  </PrivateRoute>
                }
              />
              <Route
                path="/bayi"
                element={
                  <AdminRoute>
                    <Dealer />
                    </AdminRoute>
                }
              />

              <Route
                path="/bayiler"
                element={
                  <AdminRoute>
                    <Dealers />
                  </AdminRoute>
                }
              />

              <Route
                path="/bayiler/:id"
                element={
                  <AdminRoute>
                    <DealerDetails />
                    </AdminRoute>
                }
              />

              <Route
                path="/teklifler"
                element={
                  <PrivateRoute>
                    <Offer />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profil"
                element={
                  <PrivateRoute>
                    <UserProfile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/destek"
                element={
                  <PrivateRoute>
                    <SupportList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/destek/rapor"
                element={
                  <PrivateRoute>
                    <SupportReport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/fiyat-hesaplama"
                element={
                  <PrivateRoute>
                    <FiyatHesaplama />
                  </PrivateRoute>
                }
              />
              <Route
                path="/teklif-belgesi/:teklifId"
                element={
                  <PrivateRoute>
                    <TeklifBelgesi />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sistem-mesajlari"
                element={
                  <PrivateRoute>
                    <SistemMesajlari />
                  </PrivateRoute>
                }
              />
              <Route path="/gastora/paketler" element={<AdminRoute><GastoraPackages /></AdminRoute>} />
              <Route path="/gastora/siparisler" element={<AdminRoute><GastoraOrders /></AdminRoute>} />
              <Route path="/gastora/siparis" element={<AdminRoute><GastoraOrderForm /></AdminRoute>} />
              <Route path="/gastora/siparis/:id" element={<AdminRoute><GastoraOrderForm /></AdminRoute>} />
              <Route path="/gastora/siparis/musteri/:musteriId" element={<AdminRoute><GastoraOrderForm /></AdminRoute>} />
              <Route path="/gastora/lisanslar" element={<AdminRoute><GastoraLicensePage /></AdminRoute>} />
              <Route path="/gastora/lisanslar/lisans-talep" element={<AdminRoute><GastoraLicenseRequestForm /></AdminRoute>} />
              <Route path="/gastora/lisanslar/lisans-talep/:id" element={<AdminRoute><GastoraLicenseRequestForm /></AdminRoute>} />
              <Route path="/gastora/lisans-listesi" element={<AdminRoute><GastoraLicenseList /></AdminRoute>} />
              <Route path="/pdks/paketler" element={<AdminRoute><PdksPackages /></AdminRoute>} />
              <Route path="/pdks/siparisler" element={<AdminRoute><PdksOrders /></AdminRoute>} />
              <Route path="/pdks/siparis" element={<AdminRoute><PdksOrderForm /></AdminRoute>} />
              <Route path="/pdks/siparis/:id" element={<AdminRoute><PdksOrderForm /></AdminRoute>} />
              <Route path="/pdks/lisans-listesi" element={<AdminRoute><PdksLicenses /></AdminRoute>} />
              <Route
                path="/*"
                element={
                <PrivateRoute>
                  <NotFound />
                </PrivateRoute>
                }
              />
            </Routes>

            <ToastContainer />

          </div>
    </>
  );
}

// Component to redirect to home if already authenticated
function LoginRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth(); // Access isAuthenticated from AuthContext

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return <Login />;
}

export default App;
